import { useState, useEffect, useRef, useContext } from "react";
import { ContentContext } from "../contexts/ContentContext";
import { requestQuickRepliesForCategory } from "../requests/setup_requests";
import { useTranslation } from "react-i18next";
import { componentLoadingActive, ComponentLoadingScreen } from "./Background";
import { AccountContext } from "../contexts/AccountContexts";



export const QuickReplyWindow = ({ category, setMessage }) => {
    const { t } = useTranslation('common')
    const { language } = useContext(AccountContext)
    const { categories, deletedCategories } = useContext(ContentContext)
    const [quickReplies, setQuickReplies] = useState([]);

    const [optionsShow, setOptionsShow] = useState(false)
    const dropdownRef = useRef(null);

    useEffect(() => {

        requestQuickRepliesForCategory({ category: category }).then((data) => {
            setQuickReplies(data.quick_replies)
        })

    }, [category])


    const handleClick = (e) => {
        e.preventDefault()
        setOptionsShow(!optionsShow)
    }

    const handleClickOnReply = (e, quickReply) => {
        e.preventDefault()
        setOptionsShow(false)
        setMessage(quickReply.message)
    }

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOptionsShow(false);
        }
    };

    useEffect(() => {
        // Add event listener to detect clicks outside the dropdown
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="flex flex-col justify-center items-center text-gray-800 dark:text-gray-300" ref={dropdownRef}>
            <div className="relative w-full">
                {optionsShow &&
                    <div className="absolute bottom-[2px] flex flex-col w-full gap-[2px]">
                        <h1 className="w-full bg-primary text-white text-center rounded-t-md p-1">{t(categories[category] ? (categories[category]?.locales?.[language] ? categories[category]?.locales[language] : categories[category].title) : deletedCategories[category] ? deletedCategories[category].title : "---")}</h1>
                        {quickReplies.map((quickReply, index) =>
                            <button className="btn btn-sm bg-white dark:bg-gray-600 hover:dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-white border-2 border-primary/30 hover:border-primary/70 dark:border-blue-600/30 dark:hover:border-blue-600/70" key={index} onClick={(e) => handleClickOnReply(e, quickReply)}>{quickReply.title}</button>)}
                    </div>
                }
            </div>
            <button className="btn bg-green-400 hover:bg-green-500 dark:bg-green-700 dark:hover:bg-green-800 w-64 text-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:border-gray-500" onClick={handleClick}>{t('Quick Replies')}</button>
        </div>
    )
}


export const QuickReplyWindowExtended = ({ category, setMessage, setFocusTrigger }) => {
    const { t } = useTranslation('common')
    const { language } = useContext(AccountContext)
    const { categories, deletedCategories, openErrorModal } = useContext(ContentContext)
    const [quickReplies, setQuickReplies] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState(category)

    const [optionsShow, setOptionsShow] = useState(false)
    const dropdownRef = useRef(null);


    const [mouseOverReply, setMouseOverReply] = useState(null)

    useEffect(() => {
        if (Object.keys(categories).includes(selectedCategory)) {
            componentLoadingActive(true, "quick-replies-window")
            requestQuickRepliesForCategory({ category: selectedCategory })
                .then((data) => {
                    setQuickReplies(data.quick_replies)
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
                .finally(() => {
                    componentLoadingActive(false, "quick-replies-window")
                })
        }
        else {
            setQuickReplies([])
        }
        setMouseOverReply(null)
    }, [selectedCategory])

    useEffect(() => {
        if (optionsShow) {
            setSelectedCategory(category)
            setMouseOverReply(null)
        }
    }, [optionsShow])

    const handleClick = (e) => {
        e.preventDefault()
        setOptionsShow(!optionsShow)
    }

    const handleClickOnReply = (e, quickReply) => {
        e.preventDefault()
        setOptionsShow(false)
        setMessage(quickReply.message)
        setFocusTrigger(true)
    }

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOptionsShow(false);
        }
    };

    useEffect(() => {
        // Add event listener to detect clicks outside the dropdown
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const handleMouseOver = (reply) => {
        setMouseOverReply(reply)
    }

    return (
        <div className="flex flex-col justify-center items-center text-gray-800 dark:text-gray-300 w-full max-w-[1280px]">
            {optionsShow &&
                <div className="relative w-full">

                    <div className=" absolute bottom-[2px] flex w-full h-[400px] bg-gray-100 dark:bg-gray-600 rounded-md p-1 border border-gray-400" ref={dropdownRef}>
                        <ComponentLoadingScreen tag={"quick-replies-window"} />
                        <div className=" flex flex-col w-full gap-1">
                            {/* <h1 className="w-full bg-primary text-white text-center rounded-t-md p-1 ">{t(categories[selectedCategory]?.title ?? deletedCategories[selectedCategory]?.title ?? "---")}</h1> */}
                            <select required className="select select-bordered select-sm bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300 font-bold text-center" value={selectedCategory || ""} onChange={(e) => { setSelectedCategory(e.target.value); }}>
                                {
                                    !Object.keys(categories).includes(selectedCategory) &&
                                    <option className="ltr:italic font-bold" value={selectedCategory}>{t(categories[selectedCategory]?.title ?? deletedCategories[selectedCategory]?.title ?? "UNK")}</option>
                                }
                                {Object.values(categories).map((option, index) => (
                                    <option key={index}
                                        className={`${option.id === selectedCategory && "ltr:italic font-bold"}`} value={option.id}>{option?.locales?.[language] ? option?.locales?.[language] : t(option.title)}</option>
                                ))}
                            </select>
                            <div className="flex flex-col w-full overflow-y-auto overscroll-contain">

                                {
                                    quickReplies.map((quickReply, index) =>
                                        <button className={`btn btn-sm rounded-md border-[1px] ${quickReply.id == mouseOverReply?.id ? "bg-gray-200 dark:bg-gray-700" : "bg-gray-100 dark:bg-gray-600"} hover:dark:bg-gray-700  text-gray-800 dark:text-gray-200 hover:bg-gray-200 border-primary/30 hover:border-primary/70 dark:border-gray-500 dark:hover:border-blue-400`}
                                            key={quickReply.id}
                                            onClick={(e) => handleClickOnReply(e, quickReply)}
                                            onMouseOver={() => handleMouseOver(quickReply)}
                                        >{quickReply.title}</button>)
                                }
                            </div>
                        </div>
                        <div className="divider divider-horizontal mx-1"></div>

                        <div className="flex flex-col w-full bg-white dark:bg-gray-600 overflow-auto overscroll-contain p-2 rounded-md">
                            <span className="whitespace-pre-wrap ">{mouseOverReply?.message}</span>
                        </div>
                    </div>
                </div>
            }
            <button className="btn bg-green-400 hover:bg-green-500 dark:bg-green-700 dark:hover:bg-green-800 w-64 text-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:border-gray-500" onClick={handleClick}>{t('Quick Replies')}</button>
        </div>
    )
}